import React from "react";

import "./Contact.css";
function Contact() {
  return (
    <div className="contact_main cursor ">
      <div className="color-white f-1-2 f-500"> HGS</div>
      <div className=" mt-4">
        <div className="d-flex  gap-3 mt-3 overflow-wrap-anywhere">
          <div>
            <img
              src={`https://www.pathways.in/assets/img/location_white.svg`}
              className="contact-icon"
            />
          </div>
          <div className="color-white f-1">
            HGS , Gole Gujral Talab Tillo Jammu,
            <br />
            Jammu and Kashmir (UT) 180002
          </div>
        </div>
        <div className="d-flex  gap-3 mt-3 overflow-wrap-anywhere">
          <div>
            <img
              src={`https://www.pathways.in/assets/img/email_us_white.svg`}
              className="contact-icon"
            />
          </div>
          <div className="color-white f-1">
            principal.jammu@Hermann-gmeiner-edu.org
          </div>
        </div>
        <div className="d-flex  gap-3 mt-3 overflow-wrap-anywhere">
          <div>
            <img
              src={`	https://www.pathways.in/assets/img/phone_icon_white.svg`}
              className="contact-icon"
            />
          </div>
          <div className="color-white f-1">
            (0191)- 2503326/2501651 9596379566
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
